import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { REVIEWS } from '../../../../../store/utils/files-names';

export const getAreReviewsFiltersVisibleSelector = (
  state: AppRootState
): boolean => get(state, REVIEWS).areReviewsFiltersVisible;
